export const environment = {
  production: false,
  apiUrl: 'https://gafi.softprograms-eg.com:3025',
  fZAudience: 'freeZones',
  gaadAudience: 'gaadPortal',
  gaadUrl: 'https://gafi.softprograms-eg.com:3076/#/sso/callback',
  eogaAudience: 'eogaPortal',
  eogaUrl: 'https://gafi.softprograms-eg.com:3101/#/sso/callback',
  sosUrl: 'http://54.37.224.219:3020/#/sso/callback',
  freeZonesUrl: 'http://54.37.224.219:3020/',
  diLogoutUrl: 'https://sandbox.di.gov.eg/realms/sandbox/protocol/openid-connect/logout',
  efinancePaymentUrl: 'https://test-payment.efinance.com.eg/CardPaymentRequestIntiation/index',
  // signatureAppDownloadUrlBackup:'https://drive.google.com/file/d/1JimgSVELtnSLM4fHvRI_dgfvq9u-pdX7/view?usp=drive_link',
  signatureAppDownloadUrl: 'https://www.mediafire.com/file/7v34kr521ofeba2/DigitalSignatureTool-Setup.exe/file',
  enableGafiRedirect: false,
  signatureAppDownloadV2Url: 'https://drive.google.com/file/d/1lA7xyCf1qAUjwbIknA-ERyE8SqVsNU79/view?usp=sharing',
  
  eogaPortalSoft: 'eogaPortalSoft',
  eogaPortalSoftUrl: 'https://gafi.softprograms-eg.com:3201/#/sso/callback',
};
